import React from "react";
import { Button, RadioGroup, Card, CardContent, Divider, Fab, FormControl, FormControlLabel, MenuItem, Radio, Stack, Switch, TextField, Grow, Grid, ButtonGroup, TableRow, TableBody } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goToLogin, goToUsers } from "../../routes/Coordinator";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import useForm from "../../hooks/useForm";
import axios from "axios";
import { useEffect } from "react";
import Alert from '@mui/material/Alert';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import { format } from 'date-fns'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import Chart from "react-apexcharts";


export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2A858B',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const naturezaList = [
  {
    value: "todos",
    label: "Todos",
  },
  {
    value: "inflow",
    label: "Receita",
  },
  {
    value: "outflow",
    label: "Despesa",
  },
];

const optionList = [
  {
    value: "todos",
    label: "Todos",
  },
  {
    value: "cashbook",
    label: "Livro Caixa",
  },
  {
    value: "income_tax",
    label: "Imposto de Renda",
  },
  {
    value: "cash_outflow",
    label: "Despesa Fluxo de Caixa",
  },
];
export const divStyle = {
  overflowX: 'auto',
  width: '65vw',
  position: 'relative'
};
const GraphicPage = () => {

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [rows, setRows] = useState([])
  const [doctors, setDoctors] = useState([])
  const [totalPages, setTotalPages] = useState(1)
  const [nature, setNature] = useState("")
  const [option, setOption] = useState("")
  const [formato, setFormato] = useState("")
  const [year, setYear] = useState(new Date().getFullYear())
  const [month, setMonth] = useState("")
  const [doctor_id, setDoctorId] = useState("")
  const [currentButton1, setCurrentButton1] = useState('outlined');
  const [currentButton2, setCurrentButton2] = useState('outlined');
  const [currentButton3, setCurrentButton3] = useState('outlined');
  const [currentButton4, setCurrentButton4] = useState('outlined');
  const [currentButton5, setCurrentButton5] = useState('outlined');
  const [currentButton6, setCurrentButton6] = useState('outlined');
  const [currentButton7, setCurrentButton7] = useState('outlined');
  const [currentButton8, setCurrentButton8] = useState('outlined');
  const [currentButton9, setCurrentButton9] = useState('outlined');
  const [currentButton10, setCurrentButton10] = useState('outlined');
  const [currentButton11, setCurrentButton11] = useState('outlined');
  const [currentButton12, setCurrentButton12] = useState('outlined');
  const [valorTotal, setValorTotal] = useState([])
  const [margin, setMargin] = useState("")
  const [types, setTypes] = useState([])
  const [typesOutflow, setTypesOutflow] = useState([])
  const [type_id, setType_id] = useState("")
  const [valueTypes, setValueTypes] = useState(400.0)
  const [responseBody, setResponseBody] = useState({inflow: [], outflow: []})

  const navigate = useNavigate();

  const years = () => {
    let years = []
    for (let index = 2019; index <= new Date().getFullYear(); index++) {
      years.push(index)

    }
    return years
  }

  const Doctors = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors`


    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setDoctors(response.data.doctors)
        setTotalPages(response.data.meta.total_pages)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
        if (erro.response.status === 401) {
          goToLogin(navigate)
        }
      })
  }
  useEffect(() => {

    if (localStorage.getItem("access-token") === null || localStorage.getItem("client") === null || localStorage.getItem("uid") === null) {
      alert(`Para continuar, efetue login ou registre-se.`)
      goToLogin(navigate)
    } else {
      filterType()
      filterTypeOutflow()
      Doctors()
    }
  }, [])

  const SearchYear = (year, e) => {
    setYear(year)
    let url = `${process.env.REACT_APP_BASE_URL}/transactions_consolidated_by_type?year=${year}`

    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (month) {
      url = `${url}&month=${month}`
    } else{
      return
    }


    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        let valuesTypes = Object.values(response.data)
        let values = valuesTypes.map((type => {
          return Object.keys(type).map((key) => {
            return type[key]
          })[0]
        }))
        setResponseBody(response.data)
        setValueTypes(Math.max.apply(null, values))
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }

  const SearchMonth = (month, e) => {
    setMonth(month)
    let url = `${process.env.REACT_APP_BASE_URL}/transactions_consolidated_by_type?month=${month}`

    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (year) {
      url = `${url}&year=${year}`
    }
    if (month === 1) {
      setCurrentButton1('contained');
    }
    else {
      setCurrentButton1('outlined');
    }
    if (month === 2) {
      setCurrentButton2('contained');
    }
    else {
      setCurrentButton2('outlined');
    }
    if (month === 3) {
      setCurrentButton3('contained');
    }
    else {
      setCurrentButton3('outlined');
    }
    if (month === 4) {
      setCurrentButton4('contained');
    }
    else {
      setCurrentButton4('outlined');
    }
    if (month === 5) {
      setCurrentButton5('contained');
    }
    else {
      setCurrentButton5('outlined');
    }
    if (month === 6) {
      setCurrentButton6('contained');
    }
    else {
      setCurrentButton6('outlined');
    }
    if (month === 7) {
      setCurrentButton7('contained');
    }
    else {
      setCurrentButton7('outlined');
    }
    if (month === 8) {
      setCurrentButton8('contained');
    }
    else {
      setCurrentButton8('outlined');
    }
    if (month === 9) {
      setCurrentButton9('contained');
    }
    else {
      setCurrentButton9('outlined');
    }
    if (month === 10) {
      setCurrentButton10('contained');
    }
    else {
      setCurrentButton10('outlined');
    }
    if (month === 11) {
      setCurrentButton11('contained');
    }
    else {
      setCurrentButton11('outlined');
    }
    if (month === 12) {
      setCurrentButton12('contained');
    }
    else {
      setCurrentButton12('outlined');
    }


    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        let valuesTypes = Object.values(response.data)
        let values = valuesTypes.map((type => {
          return Object.keys(type).map((key) => {
            return type[key]
          })[0]
        }))
        setResponseBody(response.data)
        setValueTypes(Math.max.apply(null, values))
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }

  const filterType = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/types?nature=inflow`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setTypes(response.data.types)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };
  const filterTypeOutflow = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/types?nature=outflow`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setTypesOutflow(response.data.types)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };
  const optionssalesoverview = {
    grid: {
      show: true,
      borderColor: "transparent",
      strokeDashArray: 2,
      padding: {
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "42%",
        endingShape: "rounded",
        borderRadius: 5,
      },
    },

    colors: ["#1e4db7", "#a7e3f4"],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      offsetX: -15,
      toolbar: {
        show: false,
      },
      foreColor: "#adb0bb",
      fontFamily: "'DM Sans',sans-serif",
      sparkline: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    legend: {
      show: false,
    },
    xaxis: {
      type: "category",
      categories: [
        "",
      ],
      labels: {
        style: {
          cssClass: "grey--text lighten-2--text fill-color",
        },
      },
    },
    yaxis: {
      show: true,
      min: 0,
      max: valueTypes,
      tickAmount: 3,
      labels: {
        style: {
          cssClass: "grey--text lighten-2--text fill-color",
        },
      },
    },
    stroke: {
      show: true,
      width: 5,
      lineCap: "butt",
      colors: ["transparent"],
    },
    tooltip: {
      theme: "dark",
    },
  };

const graphicValues = () => {
  let inflows = Object.keys(responseBody.inflow).map((key) => ({
    name: key,
    data: [responseBody.inflow[key]]
  }))
  let outflows = Object.keys(responseBody.outflow).map((key) => ({
    name: key,
    data: [responseBody.outflow[key]]
  }))
  return inflows.concat(outflows)
  }

  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Comparativo de Tipos</Typography>
          <Divider />
          <form>
            <CardContent
              sx={{
                padding: "30px",
              }}

            >
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={2} lg={2} >
                  <TextField
                    fullWidth
                    select
                    size="small"
                    required
                    id="function"
                    label="Médico"
                    onChange={(e) => setDoctorId(e.target.value)}
                    value={doctor_id}
                    name={"doctor_id"}
                    type={"doctor_id"}
                  >
                    {doctors.map((doctor) => (
                      <MenuItem key={doctor.id} value={doctor.id}>
                        {doctor.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={2} lg={2} >
                  <TextField
                    fullWidth
                    id="function"
                    onChange={(e) => SearchYear(e.target.value)}
                    value={year}
                    name={"year"}
                    type={"year"}
                    select
                    size="small"
                  >
                    {years().map((year) =>
                      <MenuItem value={year}>{year}</MenuItem>
                    )}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={8} lg={8} >
                  <ButtonGroup
                    onChange={(e) => setMonth(e.target.value)}
                    value={month}
                    variant="outlined"
                    aria-label="outlined button group">
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton1} onClick={(e) => SearchMonth(1, e)}>JAN</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton2} onClick={(e) => SearchMonth(2, e)}>FEV</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton3} onClick={(e) => SearchMonth(3, e)}>MAR</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton4} onClick={(e) => SearchMonth(4, e)}>ABR</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton5} onClick={(e) => SearchMonth(5, e)}>MAI</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton6} onClick={(e) => SearchMonth(6, e)}>JUN</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton7} onClick={(e) => SearchMonth(7, e)}>JUL</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton8} onClick={(e) => SearchMonth(8, e)}>AGO</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton9} onClick={(e) => SearchMonth(9, e)}>SET</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton10} onClick={(e) => SearchMonth(10, e)}>OUT</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton11} onClick={(e) => SearchMonth(11, e)}>NOV</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton12} onClick={(e) => SearchMonth(12, e)}>DEZ</Button>
                  </ButtonGroup>
                </Grid>
              </Grid>
            </CardContent>
          </form>
        </CardContent>
      </Card>
      <Card
        variant="outlined"
        sx={{
          paddingBottom: "0",
        }}
      >
        <CardContent
          sx={{
            paddingBottom: "16px !important",
          }}
        >
          <Typography variant="h3" sx={{ mb: 2 }}>Receita</Typography>

          <Box
            sx={{
              display: {
                sm: "flex",
                xs: "block",
              },
              alignItems: "center",
            }}
          >
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Box
                  sx={{
                    marginLeft: "auto",
                    display: "flex",
                    mt: {
                      lg: 0,
                      xs: 2,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: "secondary.main",
                        display: "flex"
                      }}
                      onChange={(e) => setType_id(e.target.value)}
                      value={type_id}
                      type={"type"}
                    >
                      {Object.keys(responseBody.inflow).map((key) => (

                        <MenuItem key={key} value={key}>
                          <Box
                            sx={{
                              backgroundColor: "secondary.main",
                              borderRadius: "50%",
                              height: 8,
                              width: 8,
                              mr: 1,
                            }}
                          />
                          {key}
                        </MenuItem>
                      ))}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Typography variant="h3" sx={{ mb: 2 }}>Despesa</Typography>

                <Box
                  sx={{
                    marginLeft: "auto",
                    mt: {
                      lg: 0,
                      xs: 2,
                    },
                  }}
                >
                  <Box
                    sx={{
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: "primary.main",
                        display: "flex"
                      }}
                      onChange={(e) => setType_id(e.target.value)}
                      value={type_id}
                      type={"type"}
                    >
                      {Object.keys(responseBody.outflow).map((key) => (

                        <MenuItem key={key} value={key}>
                          <Box
                            sx={{
                              backgroundColor: "primary.main",
                              borderRadius: "50%",
                              height: 8,
                              width: 8,
                              mr: 1,
                            }}
                          />
                          {key}
                        </MenuItem>
                      ))}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              marginTop: "25px",
            }}
          >
            <Chart
              options={optionssalesoverview}
              series={graphicValues()}
              type="bar"
              height="295px"
              />
          </Box>
        </CardContent>
      </Card>
    </Box >
  );
};

export default GraphicPage;